import { action, makeAutoObservable, observable } from "mobx";
import Store from "./Store";

export enum SettingStep {
  MainWindow,
  ConnectingServices,
  Payment,
  YnaPro,
  YnaProActive,
  Support,
  AboutProgram,
  MyCoaches,
}

export default class SettingsStore {
  isSettingsOpen: boolean = false;
  stepType: SettingStep = SettingStep.MainWindow;
  linkStarted: boolean = false;
  ynaProActivePlanId?: string;
  ynaProActivePlanName?: string;
  ynaProActivePlanType?: "success" | "warning";
  ynaProActivePrice?: number;
  ynaProActiveNextBillingDate?: string;
  selectedSubscriptionPlanId?: string;
  stepHistory: SettingStep[] = [SettingStep.MainWindow];
  ynaProCurrentActive: boolean = true;

  constructor(private store: Store) {
    makeAutoObservable(this, {
      open: action.bound,
      close: action.bound,
      onBack: action.bound,
      setStepType: action.bound,
      stepHistory: observable,
      setYnaProActivePlan: action.bound,
      setYnaProCurrentActive: action.bound,
      setSelectedSubscriptionPlanId: action.bound,
    });
  }

  open() {
    this.stepHistory = [SettingStep.MainWindow];
    this.stepType = SettingStep.MainWindow;
    this.isSettingsOpen = true;
  }

  close() {
    this.isSettingsOpen = false;
    this.stepHistory = [SettingStep.MainWindow];
    this.setYnaProActivePlan();
    this.setSelectedSubscriptionPlanId();
  }

  onBack() {
    if (this.stepHistory.length > 1) {
      this.stepHistory.pop();
      this.stepType = this.stepHistory[this.stepHistory.length - 1];
    } else {
      this.stepType = SettingStep.MainWindow;
    }

    if (this.stepType !== SettingStep.YnaProActive) {
      this.setYnaProActivePlan();
    }
  }

  setStepType(type: SettingStep) {
    this.stepHistory.push(type);
    this.stepType = type;
  }

  setLinkStarted = (value: boolean) => (this.linkStarted = value);

  isLinkStarted = () => this.linkStarted;

  setYnaProActivePlan(
    id?: string,
    name?: string,
    type?: "success" | "warning",
    price?: number,
    nextBillingDate?: string
  ) {
    this.ynaProActivePlanId = id;
    this.ynaProActivePlanName = name;
    this.ynaProActivePlanType = type;
    this.ynaProActivePrice = price;
    this.ynaProActiveNextBillingDate = nextBillingDate;
  }

  setYnaProCurrentActive(active: boolean) {
    this.ynaProCurrentActive = active;
  }

  setSelectedSubscriptionPlanId(id?: string) {
    this.selectedSubscriptionPlanId = id;
  }
}
